import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { VisitReasonViewControllerDelegate, VisitReasonViewController } from "../../Screen/VisitReason/VisitReasonViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { VisitReasonViewModel } from '../../Screen/VisitReason/VisitReasonViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class VisitReasonCoordinator implements IndexCoordinatorDelegate, VisitReasonViewControllerDelegate, TableGenericViewControllerDelegate {
    
    getRoute(): JSX.Element[] {
        return [
            this.routeTableVisitReason(),
            this.routeFormVisitReason()
        ]
    }

    private routeTableVisitReason(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepmotivovisita")
        return (<ProtectedRoute requiredPermissions={['info_bas.mot_visita.*']} path="/:base/motivo-visita" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'info_bas.mot_visita.adicionar',
                    edit: 'info_bas.mot_visita.editar',
                    delete: 'info_bas.mot_visita.excluir',
                }} 
                navigation={props} 
                viewModel={viewModel} 
                delegate={this} 
                title={"Motivo Visita"}
            />)
        }}/>)
    }

    private routeFormVisitReason(): JSX.Element {
        var viewModel = new VisitReasonViewModel()
        return (<ProtectedRoute requiredPermissions={['info_bas.mot_visita.adicionar', 'info_bas.mot_visita.editar']} path="/:base/motivo-visita/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<VisitReasonViewController navigation={props} viewModel={viewModel} delegate={this} idPrimary={idPk}/>)
        }}/>)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }
    
    add(navigation: any, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "gepmotivovisita") {
            navigation.history.push(`motivo-visita/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "gepmotivovisita") {
            navigation.history.push(`motivo-visita/cad/${idSelection}`);
            return;
        }
    }

}